export default () => {
  // Wrap an HTMLElement around another HTMLElement or an array of them.
  HTMLElement.prototype.wrapAll = function(elms) {
    const el = elms.length ? elms[0] : elms;

    // Cache the current parent and sibling of the first element.
    const parent = el.parentNode;
    const sibling = el.nextSibling;

    // Wrap the first element (is automatically removed from its
    // current parent).
    this.appendChild(el);

    // Wrap all other elements (if applicable). Each element is
    // automatically removed from its current parent and from the elms
    // array.
    while (elms.length) {
      this.appendChild(elms[0]);
    }

    // If the first element had a sibling, insert the wrapper before the
    // sibling to maintain the HTML structure; otherwise, just append it
    // to the parent.
    if (sibling) {
      parent.insertBefore(this, sibling);
    } else {
      parent.appendChild(this);
    }
  };

  const storeLocator = document.getElementById('col-main');
  const container = document.createElement('div');
  container.classList.add('container');

  if (storeLocator) {
    container.wrapAll(storeLocator);
  }

  // storeLocator.wrap('<div class="section"></div>');
  // storeLocator.wrap('<div class="container"></div>');

  if (storeLocator) {
    const title = document.getElementById('store-locator-title');
    const target = document.querySelector('.main_search_label');

    target.parentNode.insertBefore(title , target);
  }
};
